<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('user.pageTitle') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('user.pageTitle'),
          href: '/users'
        },
        {
          text: $t('create'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <fieldset>
            <legend>{{ $t('user.userAccount') }}</legend>
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <ts-loading-banner :loading="loading">
                    <div class="col-md-12">
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label required">{{
                          $t('user.employee')
                        }}</label>
                        <div class="col-md-8">
                          <a-select v-model.number="model.staff_id" style="width: 100%" :options="employees"
                            :showSearch="true" option-filter-prop="children" :filter-option="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "></a-select>
                          <div class="validate" v-if="errors.has('staff_id')">
                            {{ errors.first('staff_id') }}
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label required">{{
                          $t('user.userName')
                        }}</label>
                        <div class="col-md-8">
                          <input type="text" class="form-control" :class="{ 'is-invalid': errors.has('loginname') }"
                            v-model.trim="model.loginname" />
                          <div class="invalid-feedback" v-if="errors.has('loginname')">
                            {{ errors.first('loginname') }}
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label required">{{
                          $t('user.password')
                        }}</label>
                        <div class="col-md-8">
                          <input type="password" class="form-control" :class="{ 'is-invalid': errors.has('password') }"
                            v-model.trim="model.password" />
                          <div class="invalid-feedback" v-if="errors.has('password')">
                            {{ errors.first('password') }}
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label required">{{
                          $t('user.confirm')
                        }}</label>
                        <div class="col-md-8">
                          <input v-model.trim="model.password_confirmation" type="password" class="form-control" :class="{
                            'is-invalid': errors.has('password_confirmation')
                          }" />
                          <div class="invalid-feedback" v-if="errors.has('password_confirmation')">
                            {{ errors.first('password_confirmation') }}
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label required">{{
                          $t('user.activateType')
                        }}</label>
                        <div class="col-md-8">
                          <a-select v-model.number="model.activated_type_id">
                            <a-select-option :value="3">{{
                              $t('user.studentPickup')
                            }}</a-select-option>
                            <a-select-option :value="4">{{
                              $t('user.driver')
                            }}</a-select-option>
                            <a-select-option :value="6">{{
                              $t('user.officeStaff')
                            }}</a-select-option>
                          </a-select>
                          <div class="validate" v-if="errors.has('activated_type_id')">
                            {{ errors.first('activated_type_id') }}
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label"></label>
                        <div class="col-md-8">
                          <ts-checkbox v-model="model.is_allow_back_day">{{
                            $t('user.allowBackDay')
                          }}</ts-checkbox>
                        </div>
                      </div>
                    </div>
                  </ts-loading-banner>
                </div>
                <!-- branch list -->
                <branch-list v-model="model" :validate="errors" />
                <!-- role component -->
                <role-list v-model="model" />
                <!-- sub program -->
                <sub-program v-model="model" />
              </div>
              <div class="col-md-6">
                <permission-component v-model="model" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-right">
                <ts-button class="mr-2" @click.prevent="$router.push({ name: 'user' })">{{ $t('cancel') }}</ts-button>
                <ts-button outline color="primary" class="mr-2" :waiting="waiting_new" @click.prevent="onSaveAddNew">{{
                  $t('save_add_new')
                }}</ts-button>
                <ts-button color="primary" :waiting="waiting" @click.prevent="onSave">{{ $t('save') }}</ts-button>
              </div>
            </div>
          </fieldset>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import RoleList from './components/role-component'
import BranchList from './components/branch-list'
import SubProgram from './components/sub-program-list'
import PermissionComponent from './components/permission-component'

export default {
  name: 'UserCreate',
  components: {
    RoleList,
    BranchList,
    SubProgram,
    PermissionComponent
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        user_id: 0,
        loginname: null,
        password: null,
        password_confirmation: null,
        staff_id: null,
        cashier_location_id: null,
        activated_type_id: 6,
        disable: false,
        roles: [],
        branches: [],
        sub_programs: [],
        permissions: [],
        is_allow_back_day: false
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('user', ['employees'])
  },
  methods: {
    ...mapActions('user', ['getDataBeforCreate']),
    async fetchData() {
      this.loading = true
      await this.getDataBeforCreate()
      this.loading = false
    },
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('user/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$router.push({ name: 'user' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.$store
        .dispatch('user/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.onSaveAddNew = false
        })
    },
    clearInput() {
      this.model.user_id = 0
      this.model.loginname = null
      this.model.password = null
      this.model.password_confirmation = null
        ; (this.model.staff_id = null), (this.model.cashier_location_id = null)
      this.model.activated_type_id = 6
      this.model.disable = false
      this.model.roles = []
      this.model.branches = []
      this.model.sub_programs = []
      this.model.permissions = []
      this.model.is_allow_back_day = false
    }
  }
}
</script>
